import React, { useState } from 'react';
import axios from 'axios';

const PhonepePayment = () => {
    const [formData, setFormData] = useState({
        name: '',
        mobileNumber: '',
        amount: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'mobileNumber') {
            // Allow only digits and limit to 10 characters
            const numericValue = value.replace(/\D/g, '');
            if (numericValue.length <= 10) {
                setFormData({ ...formData, [name]: numericValue });
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handlePayment = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await axios.post('http://localhost:5000/api/pay', formData);
            if (response.data.success && response.data.url) {
                window.location.href = response.data.url;
            } else {
                setError(response.data.message || 'Payment initiation failed.');
                setLoading(false);
            }
        } catch (err) {
            if (err.response && err.response.data && err.response.data.message) {
                setError('Payment Error: ' + err.response.data.message);
            } else {
                setError('Server error while initiating payment. Make sure the backend server is running on port 5000.');
            }
            setLoading(false);
        }
    };

    return (
        <section className="contact-page pad-tb bg-gradient5" style={{ minHeight: '70vh', display: 'flex', alignItems: 'center' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-5">
                        <div className="contact-form-card" style={{ background: '#fff', padding: '40px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                            <div className="text-center mb-4">
                                <h2 style={{ fontSize: '32px', marginBottom: '10px' }}>Pay with PhonePe</h2>
                                <p style={{ color: '#666' }}>Enter your details to proceed with the secure payment.</p>
                            </div>
                            
                            {error && <div className="alert alert-danger">{error}</div>}
                            
                            <form onSubmit={handlePayment}>
                                <div className="mb-3">
                                    <label className="form-label" style={{ fontWeight: '500' }}>Full Name</label>
                                    <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} required placeholder="John Doe" style={{ padding: '12px' }} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label" style={{ fontWeight: '500' }}>Mobile Number</label>
                                    <input type="text" className="form-control" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} required pattern="\d{10}" maxLength="10" title="Please enter a valid 10-digit mobile number" placeholder="10-digit mobile number" style={{ padding: '12px' }} />
                                </div>
                                <div className="mb-4">
                                    <label className="form-label" style={{ fontWeight: '500' }}>Amount (₹)</label>
                                    <input type="number" className="form-control" name="amount" value={formData.amount} onChange={handleChange} required min="1" placeholder="Enter amount" style={{ padding: '12px' }} />
                                </div>
                                <div className="d-grid mt-4">
                                    <button type="submit" className="btn-main bg-btn3 lnk w-100" disabled={loading} style={{ border: 'none', padding: '15px', fontSize: '18px', width: '100%', borderRadius: '8px' }}>
                                        {loading ? 'Processing...' : `Pay ₹${formData.amount || '0'}`} <i className="fas fa-chevron-right fa-icon"></i><span className="circle"></span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PhonepePayment;
